import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { SpaceRoleManagementScreen } from '@confluence/space-roles/entry-points/SpaceRoleManagementScreen.tsx';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import {
	SPACE_OVERVIEW,
	ADMIN_COMPANY_HUB_PERMISSIONS,
} from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode.ts';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';

export const SpaceMembersRoute: {
	(routeMatch: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(routeMatch: {
		name: any;
		params: {
			spaceKey: any;
		};
	}): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
			};
			pageState: {
				routeName: any;
				spaceKey: any;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
		};
	};
} = ({ name: routeName, params: { spaceKey } }: RouteMatch): React.JSX.Element => {
	const { isRbacEnabled, loading } = useSpaceRoleMode();
	const isCompanyHub = isCompanyHubSpaceKey(spaceKey);

	if (isCompanyHub && routeName !== ADMIN_COMPANY_HUB_PERMISSIONS.name) {
		return <Redirection name={ADMIN_COMPANY_HUB_PERMISSIONS.name} params={{ tab: 'users' }} />;
	}

	if (!loading && !isRbacEnabled) {
		return <Redirection name={SPACE_OVERVIEW.name} params={{ spaceKey }} />;
	}

	return <SpaceRoleManagementScreen spaceKey={spaceKey} />;
};

SpaceMembersRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey },
}: {
	name: any;
	params: {
		spaceKey: any;
	};
}): {
	Screen: {
		screenEvent: {
			name: string;
			id: any;
		};
		pageState: {
			routeName: any;
			spaceKey: any;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
	};
} => ({
	Screen: {
		screenEvent: { name: 'spaceMembersScreen', id: spaceKey },
		pageState: {
			routeName: name,
			spaceKey,
		},
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
	},
});
